import { render, staticRenderFns } from "./CruiseDetailStateroom.vue?vue&type=template&id=f8dce57c&scoped=true"
import script from "./CruiseDetailStateroom.vue?vue&type=script&lang=js"
export * from "./CruiseDetailStateroom.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailStateroom.vue?vue&type=style&index=0&id=f8dce57c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dce57c",
  null
  
)

export default component.exports